import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCachedFormConfig, AppState } from '@client/model';
import { fetchFormByIdRequest } from '@client/model/policyApplicationModel';

export const usePolicyFormDefinition = (
  formId: string,
): { data: PolicyFormDefinition | undefined; isLoading: boolean } => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const hasFetchedRef = useRef<Set<string>>(new Set());
  
  const cachedFormConfig = useSelector((state: AppState) => 
    selectCachedFormConfig(state, formId)
  );
  
  useEffect(() => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    
    if (cachedFormConfig === undefined && formId && uuidRegex.test(formId) && !hasFetchedRef.current.has(formId)) {
      setIsLoading(true);
      hasFetchedRef.current.add(formId);
      dispatch(fetchFormByIdRequest({ id: formId }));
    }
  }, [formId, cachedFormConfig, dispatch]);
  
  useEffect(() => {
    if (cachedFormConfig !== undefined) {
      setIsLoading(false);
    }
  }, [cachedFormConfig]);
  
  if (cachedFormConfig?.formDefinition) {
    return { data: cachedFormConfig.formDefinition, isLoading: false };
  }
  
  return { data: undefined, isLoading };
};

